export enum UserRoleEnum {
  ADMIN = "ROLE_ADMIN",
  MANAGER = "ROLE_MANAGER",
  USER = "ROLE_USER",
}
